// Final Destinations
export const FINAL_DESTINATION = '/final_destination';
export const GET_FINAL_DESTINATIONS = '/final_destination/';
export const EXISTS_FINAL_DESTINATION = '/final_destination/exists';
export const DELETE_FINAL_DESTINATION = '/final_destination';
export const ADD_FINAL_DESTINATION = '/final_destination/';
export const UPDATE_FINAL_DESTINATION = '/final_destination';

// Final Destination types
export const FINAL_DESTINATION_TYPE = '/final_destination_type';
export const GET_FINAL_DESTINATION_TYPES = '/final_destination_type/';
export const DELETE_FINAL_DESTINATION_TYPE = '/final_destination_type';
export const ADD_FINAL_DESTINATION_TYPE = '/final_destination_type/';
export const UPDATE_FINAL_DESTINATION_TYPE = '/final_destination_type';

// Residue Category
export const RESIDUE_TYPE = '/residue_type';
export const GET_RESIDUE_TYPES = '/residue_type/';
export const DELETE_RESIDUE_TYPE = '/residue_type';
export const ADD_RESIDUE_TYPE = '/residue_type/';
export const UPDATE_RESIDUE_TYPE = '/residue_type';

// Residue Category
export const RESIDUE_CATEGORY = '/residue_category';
export const GET_RESIDUE_CATEGORIES = '/residue_category/';
export const DELETE_RESIDUE_CATEGORY = '/residue_category';
export const ADD_RESIDUE_CATEGORY = '/residue_category/';
export const UPDATE_RESIDUE_CATEGORY = '/residue_category';

// Residue Category
export const RESIDUE = '/residue';
export const GET_RESIDUES = '/residue/';
export const DELETE_RESIDUE = '/residue';
export const ADD_RESIDUE = '/residue/';
export const UPDATE_RESIDUE = '/residue';

// Guide
export const GUIDE = '/guide';
export const GET_GUIDES = '/guide/';
export const DELETE_GUIDE = '/guide';
export const CANCEL_WAREHOUSE_SEND_GUIDE = '/guide';
export const ADD_GUIDE = '/guide/';
export const UPDATE_GUIDE = '/guide';
export const REGISTER_GUIDE = '/guide/register';
export const FINAL_DESTINATION_RECEPTION_GUIDE = '/guide/final_destination/reception';
export const FINAL_DESTINATION_PRECERTIFICATION_GUIDE = '/guide/final_destination/precertification';
export const FINAL_DESTINATION_CERTIFICATION_GUIDE = '/guide/final_destination/certification';
export const STATEMENT_GUIDE = '/guide/statement';
export const DETAILS_GUIDE = '/guide/detail';
export const GUIDE_FOLDER_PATH = '/guide/folder/path';
export const WAREHOUSE_RECEPTION_GUIDE = '/guide/warehouse/reception';
export const WAREHOUSE_SEND_GUIDE = '/guide/warehouse/send';
export const GET_GUIDES_FLAT = '/guide/flat';

// Unit Measurement
export const UNIT_MEASUREMENT = '/unit_measurement';
export const UNIT_MEASUREMENT_BY_CODE = '/unit_measurement/code';
export const GET_UNIT_MEASUREMENTS = '/unit_measurement/';
export const DELETE_UNIT_MEASUREMENT = '/unit_measurement';
export const ADD_UNIT_MEASUREMENT = '/unit_measurement/';
export const UPDATE_UNIT_MEASUREMENT = '/unit_measurement';

//Guide Stutus
export const GET_STATUS_GUIDE = '/status_guide/'

// Guide Detail
export const GUIDE_DETAIL = '/guide_detail';
export const GET_GUIDE_DETAILS = '/guide_detail/';
export const DELETE_GUIDE_DETAIL = '/guide_detail';
export const ADD_GUIDE_DETAIL = '/guide_detail/';
export const UPDATE_GUIDE_DETAIL = '/guide_detail';
export const WAREHOUSE_SEND_GUIDE_DETAIL = '/guide_detail/warehouse/send';

// Traceability (Propuesta D — Fase 3)
export const GET_WAREHOUSE_RESIDUE_MOVEMENTS = '/warehouse_residue_movement/';

// Managament
export const MANAGEMENT = '/residue_management/management';
export const GET_MANAGEMENTS = '/residue_management/management/';
export const DELETE_MANAGEMENT = '/residue_management/management';
export const ADD_MANAGEMENT = '/residue_management/management/';
export const UPDATE_MANAGEMENT = '/residue_management/management';

// Treatment
export const TREATMENT = '/residue_management/treatment';
export const GET_TREATMENTS = '/residue_management/treatment/';
export const DELETE_TREATMENT = '/residue_management/treatment';
export const ADD_TREATMENT = '/residue_management/treatment/';
export const UPDATE_TREATMENT = '/residue_management/treatment';

// Treatment Detail
export const TREATMENT_DETAIL = '/residue_management/treatment_detail';
export const GET_TREATMENT_DETAILS = '/residue_management/treatment_detail/';
export const DELETE_TREATMENT_DETAIL = '/residue_management/treatment_detail';
export const ADD_TREATMENT_DETAIL = '/residue_management/treatment_detail/';
export const UPDATE_TREATMENT_DETAIL = '/residue_management/treatment_detail';

// Assignation Management Residue Final Destination
export const ASIGNATION_MANAGEMENT_RESIDUE_FINAL_DESTINATION = '/final_destination/assignation_management_residue_final_destination';
export const GET_ASIGNATION_MANAGEMENT_RESIDUE_FINAL_DESTINATIONS = '/final_destination/assignation_management_residue_final_destination/';
export const DELETE_ASIGNATION_MANAGEMENT_RESIDUE_FINAL_DESTINATION = '/final_destination/assignation_management_residue_final_destination';
export const ADD_ASIGNATION_MANAGEMENT_RESIDUE_FINAL_DESTINATION = '/final_destination/assignation_management_residue_final_destination/';
export const UPDATE_ASIGNATION_MANAGEMENT_RESIDUE_FINAL_DESTINATION = '/final_destination/assignation_management_residue_final_destination';
export const REGISTER_ASIGNATIONS_MANAGEMENT_RESIDUE_FINAL_DESTINATION = '/final_destination/assignation_management_residue_final_destination/register';

// Statement
export const STATEMENT = '/statement';
export const GET_STATEMENTS = '/statement/';
export const DELETE_STATEMENT = '/statement';
export const ADD_STATEMENT = '/statement/';
export const UPDATE_STATEMENT = '/statement';

// Status Statement
export const STATUS_STATEMENT = '/status_statement';
export const GET_STATUS_STATEMENTS = '/status_statement/';
export const DELETE_STATUS_STATEMENT = '/status_statement';
export const ADD_STATUS_STATEMENT = '/status_statement/';
export const UPDATE_STATUS_STATEMENT = '/status_statement';

// Beach Cleaning URLs

// Origin Type
export const ORIGIN_TYPE = '/origin_type';
export const GET_ORIGIN_TYPES = '/origin_type/';
export const DELETE_ORIGIN_TYPE = '/origin_type';
export const ADD_ORIGIN_TYPE = '/origin_type/';
export const UPDATE_ORIGIN_TYPE = '/origin_type';

// Beach Cleaning Reason
export const BEACH_CLEANING_REASON = '/beach_cleaning_reason';
export const GET_BEACH_CLEANING_REASONS = '/beach_cleaning_reason/';
export const DELETE_BEACH_CLEANING_REASON = '/beach_cleaning_reason';
export const ADD_BEACH_CLEANING_REASON = '/beach_cleaning_reason/';
export const UPDATE_BEACH_CLEANING_REASON = '/beach_cleaning_reason';

// Record Type
export const RECORD_TYPE = '/record_type';
export const GET_RECORD_TYPES = '/record_type/';
export const DELETE_RECORD_TYPE = '/record_type';
export const ADD_RECORD_TYPE = '/record_type/';
export const UPDATE_RECORD_TYPE = '/record_type';

// Beach Cleaning
export const BEACH_CLEANING = '/beach_cleaning';
export const GET_BEACH_CLEANINGS = '/beach_cleaning/';
export const DELETE_BEACH_CLEANING = '/beach_cleaning';
export const ADD_BEACH_CLEANING = '/beach_cleaning/';
export const UPDATE_BEACH_CLEANING = '/beach_cleaning';
export const REGISTER_BEACH_CLEANING = '/beach_cleaning/register';

// Residue Collected
export const RESIDUE_COLLECTED = '/residue_collected';
export const GET_RESIDUE_COLLECTEDS = '/residue_collected/';
export const DELETE_RESIDUE_COLLECTED = '/residue_collected';
export const ADD_RESIDUE_COLLECTED = '/residue_collected/';
export const UPDATE_RESIDUE_COLLECTED = '/residue_collected';

// Residue Conversion
export const RESIDUE_CONVERSION = '/residue_conversion';
export const GET_RESIDUE_CONVERSIONS = '/residue_conversion/';
export const DELETE_RESIDUE_CONVERSION = '/residue_conversion';
export const ADD_RESIDUE_CONVERSION = '/residue_conversion/';
export const UPDATE_RESIDUE_CONVERSION = '/residue_conversion';
export const REGISTER_RESIDUE_CONVERSION = '/residue_conversion/register';

// Residue Intake (RESPEL — manual intake to warehouse)
export const RESIDUE_INTAKE = '/residue_intake';
export const GET_RESIDUE_INTAKES = '/residue_intake/';
/** Feed unificado: ingresos directos + recepciones por guía (solo lectura). */
export const GET_RESIDUE_INBOUND_FEED = '/residue_intake/inbound_feed';
/** Timeline movimientos: directos + recepción guía + salidas parciales desde stock. */
export const GET_RESIDUE_MOVEMENTS_FEED = '/residue_intake/movements_feed';
export const DELETE_RESIDUE_INTAKE = '/residue_intake';
export const ADD_RESIDUE_INTAKE = '/residue_intake/';
export const UPDATE_RESIDUE_INTAKE = '/residue_intake';

// Warehouse Residue Stock (RESPEL projection: kg consolidados por bodega+residuo)
export const WAREHOUSE_RESIDUE_STOCK = '/warehouse_residue_stock';
export const GET_WAREHOUSE_RESIDUE_STOCKS = '/warehouse_residue_stock/';

// Envío Bodega: nuevo endpoint que consume stock consolidado en lugar de líneas de guía
export const WAREHOUSE_SEND_FROM_STOCK = '/guide_detail/warehouse/send_from_stock';
/** NP: envío desde líneas de guía recepcionadas (D-028). */
export const WAREHOUSE_SEND_FROM_GUIDE_LINES =
	'/guide_detail/warehouse/send_from_guide_lines';
export const cancelGuideLinesSend = guideId =>
	`${CANCEL_WAREHOUSE_SEND_GUIDE}/${encodeURIComponent(guideId)}/cancel_guide_lines_send`;